import MarkdownIt from 'markdown-it';
const md = new MarkdownIt();
export const renderMarkdown = (content) => {
    return md.render(content);
};
